import { GetAllMuscles, RG_TYPE } from "@project-rouge/rg-core";
import { MuscleToVector, SignedAngle, V3toVector3, Vector3toV3, distance3d, distanceToLine, getPivotRaw } from "@project-rouge/rg-three";
import { MathUtils, Vector3 } from "three";
function getFreeAreasForSpaceInstances({ building, depth, targetLevel, levelHeight }) {
	const availableAreas = [];
	const notRemovable = building.children.filter((c) => [
		RG_TYPE.Core,
		RG_TYPE.Entrance,
		RG_TYPE.Apartment
	].includes(c.type) && c.data.level === targetLevel.levelIndex);
	notRemovable.sort((a, b) => a.pos[0] - b.pos[0]);
	const muscles = GetAllMuscles(building.data.anatomy);
	for (const muscle of muscles) {
		const elOnMuscle = notRemovable.filter((e) => e.data.muscleID === muscle.id);
		const direction = MuscleToVector(muscle).normalize();
		const p1 = muscle.lockEnds[0] ? muscle.points[0] : Vector3toV3(direction.clone().negate().multiplyScalar(muscle.realLength).add(V3toVector3(muscle.points[1])));
		const p2 = muscle.lockEnds[1] ? muscle.points[1] : direction.clone().multiplyScalar(muscle.realLength).add(new Vector3().fromArray(muscle.points[0])).toArray();
		let start = p1;
		let end = p2;
		const tendon = muscle.bone.tendon;
		const tendonStart = muscle.flip ? tendon.points[1] : tendon.points[0];
		const tendonEnd = muscle.flip ? tendon.points[0] : tendon.points[1];
		const { closest: tendonStartProjection } = distanceToLine(tendonStart, [p1, p2]);
		const { closest: tendonEndProjection } = distanceToLine(tendonEnd, [p1, p2]);
		const tendonStartProjectionDir = tendonStartProjection.clone().sub(V3toVector3(tendonStart)).normalize();
		const tendonEndProjectionDir = tendonEndProjection.clone().sub(V3toVector3(tendonEnd)).normalize();
		if (Math.abs(tendonStartProjectionDir.dot(direction)) < .001) start = tendonStartProjection.toArray();
		if (Math.abs(tendonEndProjectionDir.dot(direction)) < .001) end = tendonEndProjection.toArray();
		elOnMuscle.sort((a, b) => distance3d(start, a.pos) - distance3d(start, b.pos));
		const segments = [[start, end]];
		for (const el of elOnMuscle) {
			const elStart = getPivotRaw([
				0,
				0,
				0
			], el);
			const elEnd = getPivotRaw([
				1,
				0,
				0
			], el);
			const segment = segments[segments.length - 1];
			segments.splice(segments.length - 1, 1, ...[[segment[0], elStart], [elEnd, segment[1]]]);
		}
		for (const segment of segments) {
			const angle = -SignedAngle(direction, new Vector3(1, 0, 0)) * MathUtils.RAD2DEG;
			const length = distance3d(segment[0], segment[1]);
			if (length < .5) continue;
			const aa = {
				pos: [
					segment[0][0],
					targetLevel.floorWorldBottom,
					segment[0][2]
				],
				size: [
					length,
					levelHeight,
					depth
				],
				anchor: [
					0,
					0,
					0
				],
				rot: [
					0,
					angle,
					0
				],
				levelID: targetLevel.levelIndex,
				muscle
			};
			availableAreas.push(aa);
		}
	}
	return availableAreas;
}
export { getFreeAreasForSpaceInstances };

//# sourceMappingURL=index113.js.map